export default "__VITE_ASSET__08d8fec4__"